export default __webpack_public_path__ + "static/media/thaisunlogo_circle.b224ce65.png";